var $ = require('jquery');

$('.js-content-listing__load-more').click( function(e){

	try {

		var this_button = $(this);

		if( !this_button.hasClass('is-loading') ){

			var this_section = this_button.parents('.page-section');

			var this_data = {
				labels: this_section.data('labels'),
				limit: this_section.data('limit'),
				taxQuery: this_section.data('taxQuery'),
				postType: this_section.data('postType'),
				paged: this_section.data('paged'),
				action: 'ali_content_listing_load_more',
				nonce: ali_js.content_listing_nonce,
			};
			// console.log('AJAX data = ');
			// console.log(this_data);

			this_button.addClass('is-loading');

			$.ajax({
				type: 'POST',
				url: ali_js.ajax_url,
				data: this_data,
				dataType: 'json',
				success: function( response, status, xhr ){
						// console.log('===== SUCCESS =====');
						// console.log("response: ");
						// console.log(response);

						// There ought to be an array, response.posts, where each array item is an HTML string. These strings can be appended to the results area.
						try {

							if( response.posts.length ){
								for( let i=0; i<response.posts.length; i++ ){
									this_section.find('.content-listing__results').append( response.posts[i] );
								}

								// Update the numbers in the "showing X results of Y" part.
								var post_counter = parseInt( this_section.find('.content-listing__post-count').html() );
								post_counter += response.posts.length;
								this_section.find('.content-listing__post-count').html( post_counter )

							}

							if( parseInt(response.max_num_pages) === parseInt(response.paged) ){
								// remove the load more button
								this_button.remove();

							} else if( parseInt(response.max_num_pages) > parseInt(response.paged) ){
								// console.log('*** update paged in dataset *** ');
								this_section.data('paged', parseInt(response.paged));
							}

						}
						catch(error){
							console.log(error);
						}

				},
				error: function( xhr, errorType, error ){
						// console.log('===== ERROR =====');
						// console.log(xhr);
						// console.log(errorType);
						// console.log(error);
				},
				complete: function( xhr, status ){
						// console.log('===== COMPLETE =====');
						// console.log(xhr);
						// console.log(status);

						this_button.removeClass('is-loading');
				}
			}); // END .ajax

		}

	}
	catch(error){
		console.log('Error loading more posts:');
		console.log(error);
	}

});





$('.content-listing__toggle-filters').click( function(e){
	e.preventDefault();

	$(this).next('.content-listing__filters-container').toggleClass('content-listing__filters-container--is-open')

});
